import { render, staticRenderFns } from "./LoginScaffold.vue?vue&type=template&id=6832d788&"
import script from "./LoginScaffold.vue?vue&type=script&lang=ts&"
export * from "./LoginScaffold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports